import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  useExpanded,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import SortArrowIcon from "../../Icon-SVG/SortArrowIcon";
import ExportXLSX from "../../../utils/ExportXLSX";
import ExportReactCSV from "../../../utils/ExportCSV";
import PaginationLeftIcon from "../../Icon-SVG/PaginationLeftIcon";
import PaginationRightIcon from "../../Icon-SVG/PaginationRightIcon";
import TableSpinnerIcon from "../../Icon-SVG/TableSpinnerIcon";
import TrashBucketIcon from "../../Icon-SVG/TrashBucketIcon";
import Warning from "../Warning/Warning";
import Backdrop from "../../UI/Backdrop/Backdrop";
import Row from "./Components/Row/Row";
import CustomSelect from "../CustomSelect/CustomSelect";
import PageSizeSelect, { usePageSize } from "../PageSizeSelect/PageSizeSelect";
import Overlay from "../../UI/Overlay/Overlay";
import ExpandButton from "./Components/ExpandButton";
import CheckboxTable from "./Components/CheckboxTable";
import { useDispatch, useSelector } from "react-redux";
import {
  RequestCleanRunningTab,
  RequestCloudList,
  RequestRunningSubmissions,
  RequestSubmissionsList,
  SetSubmittedFile,
} from "../../../store/actions/dashboardActions";
import { RequestNetworkDetections } from "../../../store/actions/networkDefenderActions";
import {
  RequestIocDomainsAndIps,
  RequestIocHashes,
  RequestIocUrls,
} from "../../../store/actions/analysisReportActions";
import {
  checkSubmissionisFavorite,
  customMachineOrder,
  filterByDistinctGroupID,
  getCompressedItemsOfCompressed,
  getStaticLink,
  isCompressedItself,
  isNotCompressedItself,
  isNotRelatedToCompressed,
  isRelatedToCompressed,
  selectGroupApt,
  selectGroupSeverity,
} from "../../../utils/function";

import "./styles.scss";
import {
  RequestAnalyzedEmails,
  RequestBlockedEmails,
  RequestUnblockedEmails,
} from "../../../store/actions/mailGatewayActions";
import { RequestDynamicPhishingEmails } from "../../../store/actions/phishBoxActions";

export const FILTER_BY_TIME = [
  {
    id: "1-hour",
    value: "1 hour",
  },
  { id: "3-hour", value: "3 hours" },
  { id: "1-day", value: "1 day" },
  { id: "3-day", value: "3 days" },
  { id: "7-day", value: "7 days" },
  { id: "30-day", value: "30 days" },
  { id: "all-all", value: "Show all" },
];

const progressOptions = {
  hour12: false,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};
const progressOptionsHours = {
  hour12: false,
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
};

const parseDate = (date) => {
  if (date.split(" ").length > 1) return date.split("(")[1].split(")")[0];
  return new Date(Date.parse(date)).toLocaleString("zh-CN", progressOptionsHours);
};

const severitySelect = (decisionData) => {
  if (decisionData === 0) {
    return "not suspicious";
  } else if (decisionData === 1) {
    return "suspicious";
  } else if (decisionData === 2) {
    return "malicious";
  } else {
    return "loading";
  }
};

const CustomTable = ({
  column = [],
  datavariables = [],
  dataOverview = [],
  dataOverviewDetails = [],
  dataNetworkDetections = [],
  selectedHost = "",
  dataEmail = [],
  dataSnortSuricata = [],
  dataStatistics = [],
  dataStatisticsListPopup = [],
  tableName = "",
  tableName2 = "",
  setActive,
  exportFile = false,
  paginationButtons = true,
  leftAction = false,
  isSetUrl = false,
  className = "border",
  setCurrentFile = false,
  minHeight = "475px",
  minBottom = "0px",
  customPageSize = 10,
  defaultPosition = "absolute",
  refresh = true,
  checkbox = false,
  setCheckbox = null,
  noDataText = "No Data",
  renderRowSubComponent = null,
  minHeightRow = "55px",
  subTable = false,
  tableRef = null,
  listGroupData = "",
  paginationHeight = "",
  paginationBackColor = "transparent",
  paginationBorder = false,
  intName = "",
  reportPage = false,
  tableBorder = true,
  agentHostname = "",
  filterByTime = false,
  selectedTimeFilter = null,
  setSelectedTimeFilter = null,
  defaultFilterIndex = 0,
  dataTable = [],
  loading = false,
  manualPagination = false,
}) => {
  const dispatch = useDispatch();
  const list = useSelector((state) => state?.dashboard?.list);
  const networkDetectionsSubmissions = useSelector(
    (state) => state.networkDefender.networkDetectionsSubmissions,
  );
  const analyzedEmailsSubmissions = useSelector(
    (state) => state.mailGateway.analyzedEmailsSubmissions,
  );
  const blockedEmailsSubmissions = useSelector(
    (state) => state.mailGateway.blockedEmailsSubmissions,
  );
  const unblockedEmailsSubmissions = useSelector(
    (state) => state.mailGateway.unblockedEmailsSubmissions,
  );
  const runningList = useSelector((state) => state?.dashboard?.runningList);
  const pageCount = useSelector((state) => state?.dashboard?.pageCount);
  const groupSubmissions = useSelector((state) => state.dashboard.groupSubmissions);
  const [dataSet, setDataset] = useState([]);
  const [dataListPopup, setDataListPopup] = useState([]);
  const [refreshButton, setRefreshButton] = useState(false);
  const [totalSubmisions, setTotalSubmisions] = useState();
  const [dataType, setDataType] = useState("");
  const [pageNumber, setPageNumber] = useState();
  const [paginationNumber, setPaginationNumber] = useState(1);
  const [show, setShow] = useState(false);
  const [inputPageTriggered, setInputPageTriggered] = useState(false);
  const [isPageSwitched, setIsPageSwitched] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const submissionsListLoading = useSelector((state) => state?.dashboard?.submissionsListLoading);
  const runningListLoading = useSelector((state) => state?.dashboard?.runningListLoading);
  const networkDetectionsLoading = useSelector(
    (state) => state.networkDefender.networkDetectionsLoading,
  );
  const iocUrlsLoading = useSelector((state) => state.analysisReports.iocUrlsLoading);
  const iocDomainsAndIpsLoading = useSelector(
    (state) => state.analysisReports.iocDomainsAndIpsLoading,
  );
  const iocHashesLoading = useSelector((state) => state.analysisReports.iocHashesLoading);
  const submittedFile = useSelector((state) => state?.dashboard?.submittedFile);
  const getConfig = useSelector((state) => state.integrations.getConfig);
  const user = useSelector((state) => state.users.user);
  const [pageSize, setPageSizePreference] = usePageSize(tableName, customPageSize);

  useEffect(() => {
    localStorage.setItem("tableTimeFilter", JSON.stringify(selectedTimeFilter));
  }, [selectedTimeFilter]);

  useEffect(() => {
    const storedData = localStorage.getItem(tableName);
    if (storedData && filterByTime) {
      const parsedData = JSON.parse(storedData);
      setSelectedTimeFilter(parsedData);
    }
  }, [filterByTime, tableName]);

  useEffect(() => {
    if (tableName === "statistics") {
      gotoPage(0);
    }
  }, [tableName, dataStatistics]);

  useEffect(() => {
    setDataType(tableName);

    const filterAndMapData = (filteredData, fileType = "") => {
      return filteredData.map((listData) => {
        let listTypeTags = "";
        let listNetworkTags = "";
        if (listData.fileID.includes("full_triage")) listTypeTags = " Full Tr.";
        if (listData.fileID.includes("high_evasion")) listTypeTags = " High Ev.";
        if (listData.fileID.includes("basic_evasion")) listTypeTags = " Basic Ev.";
        if (listData.fileID.includes("internet")) listNetworkTags = " Internet";
        if (listData.fileID.includes("vpn")) listNetworkTags = " Vpn";
        if (listData.fileID.includes("simulate")) listNetworkTags = " Simulate";
        if (listData.fileID.includes("disable")) listNetworkTags = " Disable";

        return {
          id: listData.fileID,
          compressedID: listData.compressedID,
          compressedIDfull: listData.compressedIDfull,
          networkTraffic: listNetworkTags,
          typeTag: listTypeTags,
          file: {
            name: listData.file_name,
            url: isCompressedItself(
              listData.compressedID,
              listData.compressedIDfull,
              listData.fileIDfull,
            )
              ? window.location.pathname +
                "?data=" +
                listData.compressedIDfull +
                "&table=" +
                `${
                  fileType === "networkDetections"
                    ? "compressed-network-detections"
                    : fileType === "analyzedEmails"
                      ? "compressed-analyzed-emails"
                      : fileType === "blockedEmails"
                        ? "compressed-blocked-emails"
                        : fileType === "unblockedEmails"
                          ? "compressed-unblocked-emails"
                          : "compressed"
                }`
              : "/analysis-reports?data=" +
                listData.parentID +
                "&state=" +
                severitySelect(listData.decision),
            fileType: fileType,
            hash: listData.fileHash,
            type: listData.fileType,
          },
          hashIcon: {
            fileType: listData.file_name.split(".").pop(),
          },
          oS: listData.machine,
          progress: listData.status,
          severity: severitySelect(listData.decision),
          VmDashboard: {
            url: "/remote-connection?data=" + listData.parentID,
          },
          apt: {
            isApt: listData.is_apt,
            aptClasses: listData.apt_classes?.[0] ? [listData.apt_classes[0]] : [],
          },
        };
      });
    };

    let filteredData;
    let fileType = "";

    switch (tableName) {
      case "runningPopup":
        filteredData = runningList?.filter(
          (filterData) =>
            filterData.compressedIDfull === listGroupData &&
            isNotCompressedItself(
              filterData.compressedID,
              filterData.compressedIDfull,
              filterData.fileIDfull,
            ),
        );
        break;
      case "compressed":
        filteredData = list?.filter(
          (filterData) =>
            filterData.compressedIDfull === listGroupData &&
            isNotCompressedItself(
              filterData.compressedID,
              filterData.compressedIDfull,
              filterData.fileIDfull,
            ),
        );
        fileType = "compressed";
        break;
      case "compressed-network-detections":
        filteredData = networkDetectionsSubmissions?.filter(
          (filterData) =>
            filterData.compressedIDfull === listGroupData &&
            isNotCompressedItself(
              filterData.compressedID,
              filterData.compressedIDfull,
              filterData.fileIDfull,
            ),
        );
        break;
      case "compressed-analyzed-emails":
        filteredData = analyzedEmailsSubmissions?.filter(
          (filterData) =>
            filterData.compressedIDfull === listGroupData &&
            isNotCompressedItself(
              filterData.compressedID,
              filterData.compressedIDfull,
              filterData.fileIDfull,
            ),
        );
        break;
      case "compressed-blocked-emails":
        filteredData = blockedEmailsSubmissions?.filter(
          (filterData) =>
            filterData.compressedIDfull === listGroupData &&
            isNotCompressedItself(
              filterData.compressedID,
              filterData.compressedIDfull,
              filterData.fileIDfull,
            ),
        );
        break;
      case "compressed-unblocked-emails":
        filteredData = unblockedEmailsSubmissions?.filter(
          (filterData) =>
            filterData.compressedIDfull === listGroupData &&
            isNotCompressedItself(
              filterData.compressedID,
              filterData.compressedIDfull,
              filterData.fileIDfull,
            ),
        );
        break;
      case "compressedStaticResults":
        filteredData = [...list, ...runningList]
          ?.filter(
            (filterData) =>
              filterData.compressedIDfull === listGroupData &&
              isNotCompressedItself(
                filterData.compressedID,
                filterData.compressedIDfull,
                filterData.fileIDfull,
              ),
          )
          .map((listData) => {
            const fileUrl = `${window.location.pathname}?data=${listData.compressedIDfull}&table=static-results&details=${listData.fileID}`;

            return {
              id: listData.fileID,
              file: {
                name: listData.file_name,
                url: fileUrl,
                urlFrom: "compressedStaticResults",
                fileType: "compressed",
                hash: listData.fileHash,
                type: listData.fileType,
              },
              hashIcon: {
                fileType: listData.file_name.split(".").pop(),
              },
              progress: listData.status,
              severity: severitySelect(listData.decision),
              staticResult: listData.static,
            };
          });
        break;
      case "listMaliciousPopup":
      case "listPopup":
      case "listOutlookPopup":
      case "listFilesharePopup":
      case "listWinsharePopup":
      case "listProxyPopup":
      case "listEndpointPopup":
      case "listPostfixEmailPopup":
      case "listImapEmailPopup":
        filteredData = list?.filter(
          (filterData) => filterData.status === "Completed" && filterData.groupID === listGroupData,
        );
        break;
      case "listNetworkDetectionsPopup":
        filteredData = networkDetectionsSubmissions?.filter(
          (filterData) => filterData.groupID === listGroupData,
        );
        fileType = "networkDetections";
        break;
      case "listAnalyzedEmailsPopup":
        filteredData = analyzedEmailsSubmissions?.filter(
          (filterData) => filterData.groupID === listGroupData,
        );
        fileType = "analyzedEmails";
        break;
      case "listBlockedEmailsPopup":
        filteredData = blockedEmailsSubmissions?.filter(
          (filterData) => filterData.groupID === listGroupData,
        );
        fileType = "blockedEmails";
        break;
      case "listUnblockedEmailsPopup":
        filteredData = unblockedEmailsSubmissions?.filter(
          (filterData) => filterData.groupID === listGroupData,
        );
        fileType = "unblockedEmails";
        break;
      case "analysisReportsPopup":
        filteredData = [...groupSubmissions];
        break;
      default:
        filteredData = [];
        break;
    }

    if (tableName === "compressedStaticResults") {
      setDataListPopup(filteredData);
    } else {
      setDataListPopup(
        filterAndMapData(filteredData, fileType).sort((a, b) => {
          if (a.typeTag === " Full Tr." && b.typeTag !== " Full Tr.") return -1;
          if (a.typeTag !== " Full Tr." && b.typeTag === " Full Tr.") return 1;

          const machineA = customMachineOrder.indexOf(a.oS);
          const machineB = customMachineOrder.indexOf(b.oS);

          return machineA - machineB;
        }),
      );
    }

    const latestGroupCounter = (id, osType) => {
      let counter = 0;

      list?.map((data) =>
        data.status === "Completed" && data.groupID === id
          ? data.machine === osType && (counter = counter + 1)
          : null,
      );

      return counter;
    };

    const setGroupCounterColumn = (groupID) =>
      ["win7", "win10", "win11", "linux22", "macos16", "andro13"]
        .filter((osType) => latestGroupCounter(groupID, osType))
        .join(",");

    if (tableName === "latest" || tableName === "documents") {
      let extractedCount = 0;

      setDataset(
        list
          ?.filter(
            (filterData) =>
              filterData.status === "Completed" && filterData.file_name !== "freerun.txt",
          )
          .filter(
            (filterData, i, arr) =>
              filterByDistinctGroupID(filterData, i, arr) &&
              (isCompressedItself(
                filterData.compressedID,
                filterData.compressedIDfull,
                filterData.fileIDfull,
              ) ||
                isNotRelatedToCompressed(filterData.compressedID)),
          )
          .map(
            (listData) =>
              listData?.status === "Completed" && {
                id: listData.fileID,
                user: listData.userName,
                time: {
                  time: listData.run_time,
                  startTime: listData.analysis_start_time,
                  completeTime: listData.complete_time,
                  submitType: listData.submitType,
                },
                hashIcon: {
                  fileType: listData.file_name.split(".").pop(),
                  submitType: listData.submitType,
                },
                file: {
                  name: listData.file_name,
                  hash: listData.fileHash,
                  type: listData.fileType,
                  url:
                    tableName2 === "historical"
                      ? "/historical-analysis?data=" + listData.groupID + "&table=latest"
                      : tableName2 === "profile"
                        ? "/profile?data=" + listData.groupID + "&table=latest"
                        : "/dashboard?data=" + listData.groupID + "&table=latest",
                },
                groupCounter: setGroupCounterColumn(listData.groupID),
                progress: listData.status,
                severity: selectGroupSeverity(list, listData.groupID),
                compressedFileCount:
                  ((extractedCount = list.filter(
                    (extractFile) =>
                      extractFile.status === "Completed" &&
                      extractFile.groupID === listData.groupID,
                  ).length),
                  extractedCount === 0
                    ? 1
                    : listData.isStatic && isRelatedToCompressed(listData.compressedID)
                      ? extractedCount - 1
                      : extractedCount),
                usersFav: listData.usersFav,
                staticResultLink: getStaticLink(
                  listData.fileID,
                  listData.compressedID,
                  tableName2 === "historical"
                    ? "historical-analysis"
                    : tableName2 === "profile"
                      ? "profile"
                      : "dashboard",
                ),
                isStatic: listData.isStatic,
                staticResult: listData.static,
                apt: selectGroupApt(list, listData.groupID),
              },
          ),
      );
    } else if (tableName === "cdr") {
      let extractedCount = 0;

      setDataset(
        list
          ?.filter(
            (filterData) =>
              filterData.status === "Completed" && filterData.file_name !== "freerun.txt",
          )
          .filter(
            (filterData, i, arr) =>
              filterByDistinctGroupID(filterData, i, arr) &&
              (isCompressedItself(
                filterData.compressedID,
                filterData.compressedIDfull,
                filterData.fileIDfull,
              ) ||
                isNotRelatedToCompressed(filterData.compressedID)),
          )
          .map(
            (listData) =>
              listData?.status === "Completed" && {
                id: listData.fileID,
                user: listData.userName,
                time: {
                  time: listData.run_time,
                  startTime: listData.analysis_start_time,
                  completeTime: listData.complete_time,
                  submitType: listData.submitType,
                },
                hashIcon: {
                  fileType: listData.file_name.split(".").pop(),
                  submitType: listData.submitType,
                },
                file: {
                  name: listData.file_name,
                  hash: listData.fileHash,
                  type: listData.fileType,
                  url: "/cdr?data=" + listData.groupID + "&table=cdr",
                },
                groupCounter: setGroupCounterColumn(listData.groupID),
                progress: listData.status,
                severity: selectGroupSeverity(list, listData.groupID),
                compressedFileCount:
                  ((extractedCount = list.filter(
                    (extractFile) =>
                      extractFile.status === "Completed" &&
                      extractFile.groupID === listData.groupID,
                  ).length),
                  extractedCount === 0
                    ? 1
                    : listData.isStatic && isRelatedToCompressed(listData.compressedID)
                      ? extractedCount - 1
                      : extractedCount),
                usersFav: listData.usersFav,
                staticResultLink: getStaticLink(
                  listData.fileID,
                  listData.compressedID,
                  tableName2 === "historical"
                    ? "historical-analysis"
                    : tableName2 === "profile"
                      ? "profile"
                      : "dashboard",
                ),
                isStatic: listData.isStatic,
                staticResult: listData.static,
                apt: selectGroupApt(list, listData.groupID),
              },
          ),
      );
    } else if (tableName === "outlook") {
      let extractedCount = 0;
      setDataset([]);

      setDataset(
        list
          ?.filter(
            (filterData, i, arr) =>
              filterData.status === "Completed" &&
              filterByDistinctGroupID(filterData, i, arr) &&
              filterData.submitType === "AddIn" &&
              (isCompressedItself(
                filterData.compressedID,
                filterData.compressedIDfull,
                filterData.fileIDfull,
              ) ||
                isNotRelatedToCompressed(filterData.compressedID)),
          )
          .map(
            (listData) =>
              listData?.status === "Completed" && {
                id: listData.fileID,
                user: listData.userName,
                time: {
                  time: listData.run_time,
                  submitType: listData.submitType,
                },
                hashIcon: {
                  fileType: listData.file_name.split(".").pop(),
                  submitType: listData.submitType,
                },
                file: {
                  name: listData.file_name,
                  hash: listData.fileHash,
                  type: listData.fileType,
                  url: "/outlook?data=" + listData.groupID + "&table=outlook",
                },
                groupCounter: setGroupCounterColumn(listData.groupID),
                progress: listData.status,
                severity: selectGroupSeverity(list, listData.groupID),
                compressedFileCount:
                  ((extractedCount = list.filter(
                    (extractFile) =>
                      extractFile.status === "Completed" &&
                      extractFile.groupID === listData.groupID,
                  ).length),
                  extractedCount === 0 ? 1 : extractedCount),
                usersFav: listData.usersFav,
                apt: selectGroupApt(list, listData.groupID),
              },
          ),
      );
    } else if (tableName === "favorite") {
      let extractedCount = 0;

      setDataset(
        list
          ?.filter(
            (filterData) =>
              checkSubmissionisFavorite(filterData.usersFav, user.email) &&
              filterData.file_name !== "freerun.txt",
          )
          .map(
            (listData) =>
              listData?.status === "Completed" && {
                id: listData.fileID,
                user: listData.userName,
                time: {
                  time: listData.run_time,
                  startTime: listData.analysis_start_time,
                  completeTime: listData.complete_time,
                  submitType: listData.submitType,
                },
                hashIcon: {
                  fileType: listData.file_name.split(".").pop(),
                  submitType: listData.submitType,
                },
                file: {
                  name: listData.file_name,
                  hash: listData.fileHash,
                  type: listData.fileType,
                  url:
                    tableName2 === "historical"
                      ? "/historical-analysis?data=" + listData.groupID + "&table=latest"
                      : tableName2 === "profile"
                        ? "/profile" + listData.groupID + "&table=latest"
                        : "/dashboard?data=" + listData.groupID + "&table=latest",
                },
                groupCounter: setGroupCounterColumn(listData.groupID),
                progress: listData.status,
                severity: selectGroupSeverity(list, listData.groupID),
                compressedFileCount:
                  ((extractedCount = list.filter(
                    (extractFile) =>
                      extractFile.status === "Completed" &&
                      extractFile.groupID === listData.groupID,
                  ).length),
                  extractedCount === 0
                    ? 1
                    : listData.isStatic && isRelatedToCompressed(listData.compressedID)
                      ? extractedCount - 1
                      : extractedCount),
                usersFav: listData.usersFav,
                staticResult: listData.static,
                staticResultLink: getStaticLink(
                  listData.fileID,
                  listData.compressedID,
                  tableName2 === "historical"
                    ? "historical-analysis"
                    : tableName2 === "profile"
                      ? "profile"
                      : "dashboard",
                ),
                isStatic: listData.isStatic,
                apt: selectGroupApt(list, listData.groupID),
              },
          ),
      );
    } else if (tableName === "malicious") {
      let extractedCount = 0;

      setDataset(
        list
          ?.filter(
            (filterData, i, arr) =>
              selectGroupSeverity(list, filterData.groupID) === "malicious" &&
              filterByDistinctGroupID(filterData, i, arr) &&
              (isCompressedItself(
                filterData.compressedID,
                filterData.compressedIDfull,
                filterData.fileIDfull,
              ) ||
                isNotRelatedToCompressed(filterData.compressedID)) &&
              filterData.file_name !== "freerun.txt",
          )
          .map((listData) => ({
            id: listData.fileID,
            user: listData.userName,
            type: listData.fileType,
            time: {
              time: listData.run_time,
              startTime: listData.analysis_start_time,
              completeTime: listData.complete_time,
              submitType: listData.submitType,
            },
            hashIcon: {
              fileType: listData.file_name.split(".").pop(),
              submitType: listData.submitType,
            },
            file: {
              name: listData.file_name,
              hash: listData.fileHash,
              type: listData.fileType,
              url: "/dashboard?data=" + listData.groupID + "&table=malicious",
            },
            groupCounter: setGroupCounterColumn(listData.groupID),
            progress: parseDate(listData.complete_time),
            severity: "malicious",
            compressedFileCount:
              ((extractedCount = list.filter(
                (extractFile) =>
                  extractFile.status === "Completed" && extractFile.groupID === listData.groupID,
              ).length),
              extractedCount === 0
                ? 1
                : listData.isStatic && isRelatedToCompressed(listData.compressedID)
                  ? extractedCount - 1
                  : extractedCount),
            staticResult: listData.static,
            staticResultLink: getStaticLink(listData.fileID, listData.compressedID, "dashboard"),
            isStatic: listData.isStatic,
            apt: selectGroupApt(list, listData.groupID),
          })),
      );
    } else if (tableName === "running") {
      let extractedCount = 0;
      setDataset([]);
      //Latest Submissions Running and reporting data convert to array
      setDataset(
        runningList
          ?.filter(
            (filterData) =>
              filterData.status !== "Completed" &&
              (isCompressedItself(
                filterData.compressedID,
                filterData.compressedIDfull,
                filterData.fileIDfull,
              ) ||
                isNotRelatedToCompressed(filterData.compressedID)),
          )
          .map((listData) => ({
            id: listData.fileID,
            user: listData.userName,
            time: {
              time: listData.run_time,
              startTime: listData.analysis_start_time,
              completeTime: listData.complete_time,
              submitType: listData.submitOptions,
            },
            file: {
              name: listData.file_name,
              hash: listData.fileHash,
              compressedID: listData.compressedID,
              compressedIDfull: listData.compressedIDfull,
              fileIDfull: listData.fileIDfull,
              url:
                isCompressedItself(
                  listData.compressedID,
                  listData.compressedIDfull,
                  listData.fileIDfull,
                ) &&
                !getCompressedItemsOfCompressed(listData.compressedIDfull, runningList).every(
                  (compressedItem) =>
                    compressedItem.status === "Error Analyser" ||
                    compressedItem.status === "Error Reporter",
                )
                  ? `/dashboard?data=${listData.compressedIDfull}&table=running`
                  : "",
            },
            VmDashboard: {
              url: "/remote-connection?data=" + listData.parentID,
            },
            oS: listData.machine,
            progress: listData.status,
            severity: "loading",
            compressedFileCount: 1,
            staticResult: listData.static,
            staticResultLink: getStaticLink(listData.fileID, listData.compressedID, "dashboard"),
          })),
      );
    } else if (tableName === "imapemail") {
      setDataset([]);

      setDataset(
        list
          ?.filter(
            (filterData, i, arr) =>
              filterData.status === "Completed" &&
              filterByDistinctGroupID(filterData, i, arr) &&
              filterData.submitType === "IMAP" &&
              (isCompressedItself(
                filterData.compressedID,
                filterData.compressedIDfull,
                filterData.fileIDfull,
              ) ||
                isNotRelatedToCompressed(filterData.compressedID)),
          )
          .map(
            (listData) =>
              listData?.status === "Completed" && {
                id: listData.fileID,
                sender: {
                  email: JSON.parse(listData.integration).sender?.includes("<")
                    ? JSON.parse(listData.integration).sender.split("<")[1].split(">")[0]
                    : JSON.parse(listData.integration).sender,
                },
                time: listData.run_time,
                hashIcon: {
                  fileType: listData.file_name.split(".").pop(),
                },
                file: {
                  name: listData.file_name,
                  hash: listData.fileHash,
                  type: listData.fileType,
                  submitType: listData.submitType,
                  url: "/imapemail?data=" + listData.groupID + "&table=imapemail",
                },
                groupCounter: setGroupCounterColumn(listData.groupID),
                recipients: JSON.parse(listData.integration).recipients,
                progress:
                  new Date(Date.parse(listData.complete_time)).toLocaleString(
                    "zh-CN",
                    progressOptions,
                  ) +
                  " (" +
                  new Date(Date.parse(listData.complete_time)).toLocaleString(
                    "zh-CN",
                    progressOptionsHours,
                  ) +
                  ")",
                severity: selectGroupSeverity(list, listData.groupID),
                apt: selectGroupApt(list, listData.groupID),
              },
          ),
      );
    } else if (tableName === "fileshare") {
      setDataset([]);

      setDataset(
        list
          ?.filter(
            (filterData, i, arr) =>
              filterData.status === "Completed" &&
              filterByDistinctGroupID(filterData, i, arr) &&
              filterData.submitType === "ShareP." &&
              (isCompressedItself(
                filterData.compressedID,
                filterData.compressedIDfull,
                filterData.fileIDfull,
              ) ||
                isNotRelatedToCompressed(filterData.compressedID)),
          )
          .map(
            (listData) =>
              listData?.status === "Completed" && {
                id: listData.fileID,
                sender: {
                  name: "Fileshare system",
                },
                path: JSON.parse(listData.integration).fullpath,
                time: listData.run_time,
                hashIcon: {
                  fileType: listData.file_name.split(".").pop(),
                },
                file: {
                  name: listData.file_name,
                  hash: listData.fileHash,
                  type: listData.fileType,
                  submitType: listData.submitType,
                  url: "/sharepoint?data=" + listData.groupID + "&table=fileshare",
                },
                groupCounter: setGroupCounterColumn(listData.groupID),
                progress:
                  new Date(Date.parse(listData.complete_time)).toLocaleString(
                    "zh-CN",
                    progressOptions,
                  ) +
                  " (" +
                  new Date(Date.parse(listData.complete_time)).toLocaleString(
                    "zh-CN",
                    progressOptionsHours,
                  ) +
                  ")",
                severity: selectGroupSeverity(list, listData.groupID),
                apt: selectGroupApt(list, listData.groupID),
              },
          ),
      );
    } else if (tableName === "winshare") {
      setDataset([]);

      setDataset(
        list
          ?.filter(
            (filterData, i, arr) =>
              filterData.status === "Completed" &&
              filterByDistinctGroupID(filterData, i, arr) &&
              filterData.submitType === "File Sh." &&
              (isCompressedItself(
                filterData.compressedID,
                filterData.compressedIDfull,
                filterData.fileIDfull,
              ) ||
                isNotRelatedToCompressed(filterData.compressedID)),
          )
          .map(
            (listData) =>
              listData?.status === "Completed" && {
                id: listData.fileID,
                sender: {
                  name: "winshare system",
                },
                path: JSON.parse(listData.integration).fullpath,
                time: listData.run_time,
                hashIcon: {
                  fileType: listData.file_name.split(".").pop(),
                },
                file: {
                  name: listData.file_name,
                  hash: listData.fileHash,
                  type: listData.fileType,
                  submitType: listData.submitType,
                  url: "/fileshare?data=" + listData.groupID + "&table=winshare",
                },
                groupCounter: setGroupCounterColumn(listData.groupID),
                progress:
                  new Date(Date.parse(listData.complete_time)).toLocaleString(
                    "zh-CN",
                    progressOptions,
                  ) +
                  " (" +
                  new Date(Date.parse(listData.complete_time)).toLocaleString(
                    "zh-CN",
                    progressOptionsHours,
                  ) +
                  ")",
                severity: selectGroupSeverity(list, listData.groupID),
                apt: selectGroupApt(list, listData.groupID),
              },
          ),
      );
    } else if (tableName === "icapweb") {
      setDataset([]);

      setDataset(
        list
          ?.filter(
            (filterData, i, arr) =>
              filterData.status === "Completed" &&
              filterByDistinctGroupID(filterData, i, arr) &&
              (filterData.submitType === "Proxy" || filterData.submitType === "Network Defender") &&
              (isCompressedItself(
                filterData.compressedID,
                filterData.compressedIDfull,
                filterData.fileIDfull,
              ) ||
                isNotRelatedToCompressed(filterData.compressedID)),
          )
          .map(
            (listData) =>
              listData?.status === "Completed" && {
                id: listData.fileID,
                sender: {
                  name: listData.integration ? JSON.parse(listData.integration).username : "-",
                },
                path: listData.integration ? JSON.parse(listData.integration).client_ip : "-",
                time: {
                  time: listData.run_time,
                  startTime: listData.analysis_start_time,
                  completeTime: listData.complete_time,
                  submitType: listData.submitType,
                },
                hashIcon: {
                  fileType: listData.file_name.split(".").pop(),
                },
                file: {
                  name: listData.file_name,
                  hash: listData.fileHash,
                  type: listData.fileType,
                  submitType: listData.submitType,
                  url: "/proxy?data=" + listData.groupID + "&table=icapweb",
                },
                groupCounter: setGroupCounterColumn(listData.groupID),
                progress:
                  new Date(Date.parse(listData.complete_time)).toLocaleString(
                    "zh-CN",
                    progressOptions,
                  ) +
                  " (" +
                  new Date(Date.parse(listData.complete_time)).toLocaleString(
                    "zh-CN",
                    progressOptionsHours,
                  ) +
                  ")",
                severity: selectGroupSeverity(list, listData.groupID),
                apt: selectGroupApt(list, listData.groupID),
              },
          ),
      );
    } else if (tableName === "tapweb") {
      setDataset([]);

      setDataset(
        list
          ?.filter(
            (filterData, i, arr) =>
              filterData.status === "Completed" &&
              filterByDistinctGroupID(filterData, i, arr) &&
              filterData.submitType === "Tap Interface" &&
              (isCompressedItself(
                filterData.compressedID,
                filterData.compressedIDfull,
                filterData.fileIDfull,
              ) ||
                isNotRelatedToCompressed(filterData.compressedID)),
          )
          .map(
            (listData) =>
              listData?.status === "Completed" && {
                id: listData.fileID,
                sender: {
                  name: JSON.parse(listData.integration).username,
                },
                path: JSON.parse(listData.integration).client_ip,
                time: listData.run_time,
                hashIcon: {
                  fileType: listData.file_name.split(".").pop(),
                },
                file: {
                  name: listData.file_name,
                  hash: listData.fileHash,
                  type: listData.fileType,
                  submitType: listData.submitType,
                  url: "/tapper?data=" + listData.groupID + "&table=tapweb",
                },
                groupCounter: setGroupCounterColumn(listData.groupID),
                progress:
                  new Date(Date.parse(listData.complete_time)).toLocaleString(
                    "zh-CN",
                    progressOptions,
                  ) +
                  " (" +
                  new Date(Date.parse(listData.complete_time)).toLocaleString(
                    "zh-CN",
                    progressOptionsHours,
                  ) +
                  ")",
                severity: selectGroupSeverity(list, listData.groupID),
                apt: selectGroupApt(list, listData.groupID),
              },
          ),
      );
    } else if (tableName === "endpoint") {
      setDataset([]);

      setDataset(
        list
          ?.filter(
            (filterData, i, arr) =>
              filterData.status === "Completed" &&
              filterByDistinctGroupID(filterData, i, arr) &&
              (filterData.submitType === "Endpoint" || filterData.submitType === "Agent") &&
              (isCompressedItself(
                filterData.compressedID,
                filterData.compressedIDfull,
                filterData.fileIDfull,
              ) ||
                isNotRelatedToCompressed(filterData.compressedID)),
          )
          .map(
            (listData) =>
              listData?.status === "Completed" && {
                id: listData.fileID,
                sender: {
                  name:
                    listData?.submitType === "Endpoint"
                      ? JSON.parse(listData.integration).username
                      : listData?.userName,
                },
                path:
                  listData?.submitType === "Endpoint"
                    ? JSON.parse(listData.integration).hostname
                    : listData?.agenthost,
                time: listData.run_time,
                hashIcon: {
                  fileType: listData.file_name.split(".").pop(),
                },
                file: {
                  name: listData.file_name,
                  hash: listData.fileHash,
                  type: listData.fileType,
                  submitType: listData.submitType,
                  url: "/submissions?data=" + listData.groupID + "&table=endpoint",
                },
                groupCounter: setGroupCounterColumn(listData.groupID),
                progress:
                  new Date(Date.parse(listData.complete_time)).toLocaleString(
                    "zh-CN",
                    progressOptions,
                  ) +
                  " (" +
                  new Date(Date.parse(listData.complete_time)).toLocaleString(
                    "zh-CN",
                    progressOptionsHours,
                  ) +
                  ")",
                severity: selectGroupSeverity(list, listData.groupID),
                apt: selectGroupApt(list, listData.groupID),
              },
          ),
      );
    } else if (tableName === "postfixemail") {
      setDataset([]);

      setDataset(
        list
          ?.filter(
            (filterData, i, arr) =>
              filterData.status === "Completed" &&
              filterByDistinctGroupID(filterData, i, arr) &&
              filterData.submitType === "Postf." &&
              (isCompressedItself(
                filterData.compressedID,
                filterData.compressedIDfull,
                filterData.fileIDfull,
              ) ||
                isNotRelatedToCompressed(filterData.compressedID)),
          )
          .map(
            (listData) =>
              listData?.status === "Completed" && {
                id: listData.fileID,
                sender: {
                  name: JSON.parse(listData.integration).sender.split("<")[0],
                  email: JSON.parse(listData.integration).sender.split("<")[1],
                },
                time: listData.run_time,
                hashIcon: {
                  fileType: listData.file_name.split(".").pop(),
                },
                file: {
                  name: listData.file_name,
                  hash: listData.fileHash,
                  type: listData.fileType,
                  submitType: listData.submitType,
                  url: "/postfixemail?data=" + listData.groupID + "&table=postfixemail",
                },
                groupCounter: setGroupCounterColumn(listData.groupID),
                recipients: JSON.parse(listData.integration).recipients,
                progress:
                  new Date(Date.parse(listData.complete_time)).toLocaleString(
                    "zh-CN",
                    progressOptions,
                  ) +
                  " (" +
                  new Date(Date.parse(listData.complete_time)).toLocaleString(
                    "zh-CN",
                    progressOptionsHours,
                  ) +
                  ")",
                severity: selectGroupSeverity(list, listData.groupID),
                apt: selectGroupApt(list, listData.groupID),
              },
          ),
      );
    } else if (tableName === "agent") {
      setDataset(
        list
          ?.filter(
            (filterData) =>
              filterData.status === "Completed" && filterData.agenthost === agentHostname,
          )
          .filter(
            (filterData, i, arr) =>
              filterByDistinctGroupID(filterData, i, arr) &&
              (isCompressedItself(
                filterData.compressedID,
                filterData.compressedIDfull,
                filterData.fileIDfull,
              ) ||
                isNotRelatedToCompressed(filterData.compressedID)),
          )
          .map(
            (listData) =>
              listData?.status === "Completed" &&
              listData.agenthost === agentHostname && {
                id: listData.fileID,
                user: listData.userName,
                time: {
                  time: listData.run_time,
                  startTime: listData.analysis_start_time,
                  completeTime: listData.complete_time,
                  submitType: "",
                },
                file: {
                  name: listData.file_name,
                  hash: listData.fileHash,
                  type: listData.fileType,
                  url: "/agentstatus?data=" + listData.groupID + "&table=agent",
                },
                severity: selectGroupSeverity(list, listData.groupID),
                usersFav: listData.usersFav,
                apt: selectGroupApt(list, listData.groupID),
              },
          ),
      );
    } else if (tableName === "cloud") {
      let extractedCount = 0;
      setDataset(
        list
          ?.filter((filterData) => filterData.file_name !== "freerun.txt")
          .filter(
            (filterData, i, arr) =>
              filterByDistinctGroupID(filterData, i, arr) &&
              (isCompressedItself(
                filterData.compressedID,
                filterData.compressedIDfull,
                filterData.fileIDfull,
              ) ||
                isNotRelatedToCompressed(filterData.compressedID)),
          )
          .map(
            (listData) =>
              listData && {
                id: listData.fileID,
                time: {
                  time: listData.run_time,
                  startTime: listData.analysis_start_time,
                  completeTime: listData.complete_time,
                  submitType: "",
                },
                file: {
                  name: listData.file_name,
                  hash: listData.fileHash,
                  type: listData.fileType,
                  url: user ? "/submission-list?data=" + listData.groupID + "&table=latest" : "",
                },
                groupCounter: setGroupCounterColumn(listData.groupID),
                severity: selectGroupSeverity(list, listData.groupID),
                compressedFileCount:
                  ((extractedCount = list.filter(
                    (extractFile) => extractFile.groupID === listData.groupID,
                  ).length),
                  extractedCount === 0
                    ? 1
                    : listData.isStatic && isRelatedToCompressed(listData.compressedID)
                      ? extractedCount - 1
                      : extractedCount),
                staticResultLink: getStaticLink(
                  listData.fileID,
                  listData.compressedID,
                  "submission-list",
                ),

                isStatic: listData.isStatic,
                staticResult: listData.static,
                apt: selectGroupApt(list, listData.groupID),
              },
          ),
      );
    }
  }, [runningList, list, tableName, getConfig]);

  const data = useMemo(() => {
    if (tableName === "dropped") {
      return datavariables;
    } else if (tableName === "overview") {
      return dataOverview;
    } else if (tableName === "overviewDetails") {
      return dataOverviewDetails;
    } else if (tableName === "snortSuricata") {
      return dataSnortSuricata;
    } else if (tableName === "networkDetections") {
      return dataNetworkDetections;
    } else if (tableName === "usbtransfer") {
      return dataEmail;
    } else if (tableName === "statistics") {
      return dataStatistics;
    } else if (tableName === "statisticsListPopup") {
      return dataStatisticsListPopup;
    } else if (tableName === "statisticsListCompressedPopup") {
      return dataStatisticsListPopup;
    } else if (tableName === "urls") {
      return dataTable;
    } else if (tableName === "domainsAndIps") {
      return dataTable;
    } else if (tableName === "hashes") {
      return dataTable;
    } else if (tableName === "hostsAndDomains") {
      return dataTable;
    } else if (tableName === "analyzedEmails") {
      return dataTable;
    } else if (tableName === "blockedEmails") {
      return dataTable;
    } else if (tableName === "unblockedEmails") {
      return dataTable;
    } else if (tableName === "dynamicPhishingEmails") {
      return dataTable;
    } else if (
      tableName === "listPopup" ||
      tableName === "listMaliciousPopup" ||
      tableName === "listImapEmailPopup" ||
      tableName === "listFilesharePopup" ||
      tableName === "listWinsharePopup" ||
      tableName === "listProxyPopup" ||
      tableName === "listEndpointPopup" ||
      tableName === "listPostfixEmailPopup" ||
      tableName === "compressed" ||
      tableName === "compressed-network-detections" ||
      tableName === "runningPopup" ||
      tableName === "listOutlookPopup" ||
      tableName === "listNetworkDetectionsPopup" ||
      tableName === "analysisReportsPopup" ||
      tableName === "compressedStaticResults" ||
      tableName === "listAnalyzedEmailsPopup" ||
      tableName === "listBlockedEmailsPopup" ||
      tableName === "listUnblockedEmailsPopup" ||
      tableName === "compressed-analyzed-emails" ||
      tableName === "compressed-blocked-emails" ||
      tableName === "compressed-unblocked-emails"
    ) {
      return dataListPopup;
    } else {
      return dataSet;
    }
  }, [
    dataSet,
    dataListPopup,
    datavariables,
    dataOverviewDetails,
    dataSnortSuricata,
    dataNetworkDetections,
    dataTable,
    dataEmail,
    dataOverview,
    dataStatistics,
  ]);

  const columns = useMemo(() => {
    return column;
  }, [column]);

  const pageSwitchHandler = (numPage) => {
    if (numPage >= 0) {
      toggleAllRowsExpanded(false);
      if (tableRef) {
        tableRef.current.scrollIntoView();
      }
      setPaginationNumber(numPage + 1);
      gotoPage(numPage);
    } else {
      setPaginationNumber(0);
      gotoPage(0);
    }
    setInputPageTriggered(false);
    setIsPageSwitched(true);
  };

  const inputPageSwitchHandler = (numPage) => {
    if (numPage >= 0) {
      toggleAllRowsExpanded(false);
      if (tableRef) {
        tableRef.current.scrollIntoView();
      }
      setPaginationNumber(numPage + 1);
      gotoPage(numPage);
    } else {
      setPaginationNumber(0);
      gotoPage(0);
    }
    setInputPageTriggered(true);
    setIsPageSwitched(true);
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    page,
    prepareRow,
    state,
    nextPage,
    previousPage,
    pageOptions,
    gotoPage,
    setPageSize,
    selectedFlatRows,
    visibleColumns,
    toggleAllRowsExpanded,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize,
      },
      autoResetPage: false,
      autoResetFilters: false,
      manualPagination,
      manualFilters: manualPagination, // if there is server side pagination there have to be server side filtering
      pageCount: manualPagination ? pageCount : -1,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
    (hooks) => {
      leftAction && !checkbox
        ? hooks.visibleColumns.push((columns) => [
            {
              id: "expander",
              Cell: ExpandButton,
            },
            ...columns,
          ])
        : checkbox &&
          hooks.visibleColumns.push((columns) => [
            {
              id: "selection",
              Header: ({ getToggleAllRowsSelectedProps }) => (
                <CheckboxTable id={new Date()} {...getToggleAllRowsSelectedProps()} />
              ),
              Cell: ({ row }) => <CheckboxTable id={row.id} {...row.getToggleRowSelectedProps()} />,
            },
            ...columns,
          ]);
    },
  );
  const { pageIndex, filters } = state;

  // A new search can shrink the result below the current page, leaving it empty.
  const isFirstFilterRender = useRef(true);
  useEffect(() => {
    if (isFirstFilterRender.current) {
      isFirstFilterRender.current = false;
      return;
    }
    gotoPage(0);
    setPaginationNumber(1);
  }, [filters]);

  // The report/pdf renders without pagination controls, so a page slice would
  // silently drop every row past the first page.
  const displayRows = reportPage ? rows : page;

  useEffect(() => {
    if (submittedFile && submittedFile.state === true) {
      if (
        (submittedFile.from === "staticSubmit" ||
          submittedFile.from === "allGetPreStaticResults") &&
        (tableName === "latest" || tableName === "favorite")
      ) {
        dispatch(
          RequestSubmissionsList({
            selectedTimeFilter,
            customPageSize: pageSize,
            pageNumber: pageIndex + 1,
            tableName,
            agentHostname,
            filters,
          }),
        );
      } else if (submittedFile.from === "runningGetPreStaticResults") {
        // dispatch(RequestRunningSubmissions());
      } else {
        dispatch(RequestRunningSubmissions());
      }
      dispatch(SetSubmittedFile({ state: false, from: null }));
    }
  }, [submittedFile]);

  useEffect(() => {
    if (filterByTime && !selectedTimeFilter) return;
    if (
      tableName === "latest" ||
      tableName === "documents" ||
      tableName === "malicious" ||
      tableName === "imapemail" ||
      tableName === "fileshare" ||
      tableName === "winshare" ||
      tableName === "icapweb" ||
      tableName === "tapweb" ||
      tableName === "endpoint" ||
      tableName === "postfixemail" ||
      tableName === "agent" ||
      tableName === "outlook" ||
      tableName === "favorite" ||
      tableName === "cdr"
    ) {
      const delayTimeInMs = inputPageTriggered ? 700 : 400;
      const delayDebounceFn = setTimeout(() => {
        dispatch(
          RequestSubmissionsList({
            selectedTimeFilter,
            customPageSize: pageSize,
            pageNumber: pageIndex + 1,
            tableName,
            agentHostname,
            filters,
          }),
        );
      }, delayTimeInMs);
      return () => clearTimeout(delayDebounceFn);
    } else if (tableName === "running") {
      dispatch(RequestRunningSubmissions());
    } else if (tableName === "cloud") {
      dispatch(
        RequestCloudList({
          selectedTimeFilter,
          customPageSize: pageSize,
          pageNumber: pageIndex + 1,
          tableName,
          agentHostname,
          filters,
        }),
      );
    }
  }, [
    tableName,
    selectedTimeFilter,
    dispatch,
    pageIndex,
    pageSize,
    filterByTime,
    agentHostname,
    inputPageTriggered,
    filters,
  ]);

  useEffect(() => {
    //Refreshes every 20 seconds for update components
    let interval;
    if (
      tableName === "latest" ||
      tableName === "documents" ||
      tableName === "malicious" ||
      tableName === "imapemail" ||
      tableName === "fileshare" ||
      tableName === "winshare" ||
      tableName === "icapweb" ||
      tableName === "tapweb" ||
      tableName === "endpoint" ||
      tableName === "postfixemail" ||
      tableName === "agent" ||
      tableName === "outlook" ||
      tableName === "favorite" ||
      tableName === "cdr"
    ) {
      interval = setInterval(() => {
        dispatch(
          RequestSubmissionsList({
            selectedTimeFilter,
            customPageSize: pageSize,
            pageNumber: pageIndex + 1,
            tableName,
            agentHostname,
            filters,
          }),
        );
      }, 28000);
    } else if (tableName === "networkDetections") {
      interval = setInterval(() => {
        dispatch(RequestNetworkDetections({ host: selectedHost, timeFilter: selectedTimeFilter }));
      }, 28000);
    } else if (tableName === "urls") {
      if (selectedTimeFilter?.id === "1-hour" || selectedTimeFilter?.id === "3-hour") {
        interval = setInterval(() => {
          dispatch(RequestIocUrls(selectedTimeFilter));
        }, 28000);
      }
    } else if (tableName === "domainsAndIps") {
      if (selectedTimeFilter?.id === "1-hour" || selectedTimeFilter?.id === "3-hour") {
        interval = setInterval(() => {
          dispatch(RequestIocDomainsAndIps(selectedTimeFilter));
        }, 28000);
      }
    } else if (tableName === "hashes") {
      if (selectedTimeFilter?.id === "1-hour" || selectedTimeFilter?.id === "3-hour") {
        interval = setInterval(() => {
          dispatch(RequestIocHashes(selectedTimeFilter));
        }, 28000);
      }
    } else if (tableName === "running") {
      interval = setInterval(() => {
        dispatch(RequestRunningSubmissions());
      }, 28000);
    } else if (tableName === "cloud") {
      interval = setInterval(() => {
        dispatch(
          RequestCloudList({
            selectedTimeFilter,
            customPageSize: pageSize,
            pageNumber: pageIndex + 1,
            tableName,
            agentHostname,
            filters,
          }),
        );
      }, 28000);
    }
    return () => clearInterval(interval);
  }, [
    dispatch,
    selectedTimeFilter,
    tableName,
    selectedHost,
    pageSize,
    pageIndex,
    agentHostname,
    filters,
  ]);

  let leftIconDisabled = false;
  let rightIconDisabled = false;
  if (tableName === "running") {
    leftIconDisabled = pageIndex === 0;
    rightIconDisabled = pageIndex === pageOptions.length - 1;
  } else {
    leftIconDisabled = pageNumber === 0;
    rightIconDisabled = pageNumber === totalSubmisions - 1;
  }

  useEffect(() => {
    if (setCheckbox) {
      selectedFlatRows.length && setCheckbox(selectedFlatRows.map((row) => row.original));
    }
  }, [selectedFlatRows, setCheckbox]);

  const refreshP = async () => {
    setRefreshButton(true);
    if (
      dataType === "latest" ||
      dataType === "documents" ||
      dataType === "malicious" ||
      dataType === "favorite" ||
      dataType === "postfixemail" ||
      dataType === "imapemail" ||
      dataType === "outlook" ||
      dataType === "fileshare" ||
      dataType === "winshare" ||
      dataType === "icapweb" ||
      dataType === "tapweb" ||
      dataType === "endpoint" ||
      dataType === "usbtransfer" ||
      dataType === "agent" ||
      dataType === "cdr"
    ) {
      dispatch(
        RequestSubmissionsList({
          selectedTimeFilter,
          customPageSize: pageSize,
          pageNumber: pageIndex + 1,
          tableName: dataType,
          agentHostname,
          filters,
        }),
      );
    } else if (dataType === "running") {
      dispatch(RequestRunningSubmissions());
      setActive("Running");
    } else if (dataType === "networkDetections") {
      dispatch(RequestNetworkDetections({ host: selectedHost, timeFilter: selectedTimeFilter }));
    } else if (dataType === "urls") {
      dispatch(RequestIocUrls(selectedTimeFilter));
    } else if (dataType === "domainsAndIps") {
      dispatch(RequestIocDomainsAndIps(selectedTimeFilter));
    } else if (dataType === "hashes") {
      dispatch(RequestIocHashes(selectedTimeFilter));
    } else if (dataType === "analyzedEmails") {
      dispatch(RequestAnalyzedEmails({ host: selectedHost, timeFilter: selectedTimeFilter }));
    } else if (dataType === "blockedEmails") {
      dispatch(RequestBlockedEmails({ host: selectedHost, timeFilter: selectedTimeFilter }));
    } else if (dataType === "unblockedEmails") {
      dispatch(RequestUnblockedEmails({ host: selectedHost, timeFilter: selectedTimeFilter }));
    } else if (dataType === "dynamicPhishingEmails") {
      dispatch(RequestDynamicPhishingEmails());
    } else if (dataType === "cloud") {
      dispatch(
        RequestCloudList({
          selectedTimeFilter,
          customPageSize: pageSize,
          pageNumber: pageIndex + 1,
          tableName,
          agentHostname,
          filters,
        }),
      );
    }
  };

  const pageSizeChangeHandler = (size) => {
    toggleAllRowsExpanded(false);
    setPageSizePreference(size);
    gotoPage(0);
    setPaginationNumber(1);
  };

  useEffect(() => {
    setPageSize(pageSize);
  }, [pageSize, setPageSize]);

  const onSelectItem = (selectedTimeFilter) => {
    setRefreshButton(true);
    localStorage.setItem(tableName, JSON.stringify(selectedTimeFilter));
  };

  const cleanListHandler = () => {
    setShow(false);
    dispatch(RequestCleanRunningTab());
  };

  useEffect(() => {
    if (submittedFile && submittedFile.state === true) {
      if (submittedFile.from === "staticSubmit") {
        tableName = "latest";
        setDataType("latest");
        setActive("Latest");
      } else if (
        submittedFile.from !== "runningGetPreStaticResults" &&
        submittedFile.from !== "allGetPreStaticResults"
      ) {
        tableName = "running";
        setDataType("running");
        setActive("Running");
      }
      dispatch(SetSubmittedFile({ state: false, from: null }));
    }
  }, [submittedFile]);

  useEffect(() => {
    if (
      !submissionsListLoading &&
      !networkDetectionsLoading &&
      !iocUrlsLoading &&
      !iocDomainsAndIpsLoading &&
      !iocHashesLoading &&
      !runningListLoading &&
      !loading
    ) {
      setRefreshButton(false);
      setIsPageSwitched(false);
    }
  }, [
    submissionsListLoading,
    networkDetectionsLoading,
    iocUrlsLoading,
    iocDomainsAndIpsLoading,
    iocHashesLoading,
    runningListLoading,
    loading,
  ]);

  useEffect(() => {
    gotoPage(0);
    setPaginationNumber(1);
  }, [gotoPage, tableName, selectedTimeFilter]);

  useEffect(() => {
    if (
      dataType === "latest" ||
      dataType === "documents" ||
      dataType === "malicious" ||
      dataType === "favorite" ||
      dataType === "postfixemail" ||
      dataType === "imapemail" ||
      dataType === "outlook" ||
      dataType === "fileshare" ||
      dataType === "winshare" ||
      dataType === "icapweb" ||
      dataType === "tapweb" ||
      dataType === "endpoint" ||
      dataType === "usbtransfer" ||
      dataType === "agent" ||
      dataType === "cdr"
    ) {
      setIsTransitioning(true);
    }
  }, [dataType]);

  useEffect(() => {
    if (!submissionsListLoading) {
      setIsTransitioning(false);
    }
  }, [submissionsListLoading]);

  return (
    <>
      <div style={tableName === "dropped" ? { position: "relative" } : {}}>
        <div
          className={`custom-table ${className} ${
            subTable ? "custom-table__sub-table" : "custom-table__main-table"
          }`}
          style={{ minHeight, height: "300px !important" }}
          ref={tableRef}>
          <div className={`custom-table-button-block custom-table-button-block--${tableName}`}>
            {exportFile && (
              <>
                <ExportXLSX
                  csvData={selectedFlatRows.length ? selectedFlatRows : data}
                  fileName={tableName}
                  selected={selectedFlatRows.length}
                  columns={columns}
                  manualPagination={manualPagination}
                  agentHostname={agentHostname}
                  selectedTimeFilter={selectedTimeFilter}
                />
                <ExportReactCSV
                  csvData={selectedFlatRows.length ? selectedFlatRows : data}
                  selected={selectedFlatRows.length}
                  tableName={tableName}
                  fileName={`${tableName}.csv`}
                  headers={columns.map((column) => ({
                    label: column.Header,
                    key: column.accessor,
                  }))}
                  agentHostname={agentHostname}
                  selectedTimeFilter={selectedTimeFilter}
                  manualPagination={manualPagination}
                />
              </>
            )}
            {tableName === "running" ? (
              <button
                className="custom-table-button-block__clean-list"
                onClick={() => setShow(true)}>
                <TrashBucketIcon color="var(--text-color-card)" width="20" height="20" />
              </button>
            ) : null}
            {refresh && (
              <button
                style={{ backgroundColor: "transparent", border: "none" }}
                onClick={() => refreshP()}>
                <TableSpinnerIcon
                  className="spinner"
                  spin={
                    (submissionsListLoading && refreshButton) ||
                    (networkDetectionsLoading && refreshButton) ||
                    (iocUrlsLoading && refreshButton) ||
                    (iocDomainsAndIpsLoading && refreshButton) ||
                    (iocHashesLoading && refreshButton) ||
                    (runningListLoading && refreshButton) ||
                    (loading && refreshButton)
                  }
                />
              </button>
            )}
            {filterByTime ? (
              <div className="custom-table-button-block-filter">
                <p>Filter by last: </p>
                <CustomSelect
                  data={FILTER_BY_TIME}
                  select={selectedTimeFilter}
                  setSelected={setSelectedTimeFilter}
                  width="120px"
                  height="26px"
                  defaultIndex={defaultFilterIndex}
                  onSelectItem={onSelectItem}
                />
              </div>
            ) : null}
          </div>
          <table
            style={{
              ...(tableBorder ? { border: "none" } : {}),
              ...(isTransitioning ? { opacity: "0.4" } : {}),
            }}
            id={tableName}
            {...getTableProps()}
            className={`${className} ${reportPage && "custom-table-report"}`}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => {
                    const headerText = column.render("Header");
                    const isOSinListPopup =
                      (headerText === "OS/R" ||
                        headerText === "OS" ||
                        headerText === "AI" ||
                        headerText === "Verdict") &&
                      ((tableName.includes("list") && tableName.includes("Popup")) ||
                        tableName === "compressed");

                    // Add spacing only if tableName === "compressed"
                    let displayHeader = headerText;
                    if (tableName === "compressed") {
                      if (headerText === "AI") {
                        displayHeader = <>&nbsp;{headerText}</>;
                      } else if (headerText === "Verdict") {
                        displayHeader = <>&nbsp;&nbsp;&nbsp;{headerText}</>;
                      }
                    }

                    return (
                      <th key={column.id} className={column.className}>
                        <div className={`th-row ${isOSinListPopup ? "custom-th-row" : ""}`}>
                          <>{column.Filter && column.canFilter ? column.render("Filter") : null}</>
                          {column.sort ? (
                            <div
                              className="th-sort"
                              {...column.getHeaderProps(column.getSortByToggleProps())}>
                              <p>{displayHeader}</p>
                              {column.Header && (
                                <span className="m-l-5">
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <SortArrowIcon desc="var(--sort-color-asc)" />
                                    ) : (
                                      <SortArrowIcon asc="var(--sort-color-desc)" />
                                    )
                                  ) : column.id !== "action" ? (
                                    <SortArrowIcon />
                                  ) : (
                                    ""
                                  )}
                                </span>
                              )}
                            </div>
                          ) : (
                            <p className={`${isOSinListPopup ? "custom-p-text" : ""}`}>
                              {displayHeader}
                            </p>
                          )}
                        </div>
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()} style={{ minHeight: "minHeightRow" }}>
              {data && data.length ? (
                displayRows.map((row, index) => {
                  prepareRow(row);
                  return (
                    <Row
                      arrow={leftAction}
                      key={index}
                      row={row}
                      setCurrentFile={setCurrentFile}
                      visibleColumns={visibleColumns}
                      renderRowSubComponent={renderRowSubComponent}
                      isSetUrl={isSetUrl}
                      minHeight={minHeightRow}
                      tableName={tableName}
                      reportPage={reportPage}
                    />
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan={columns.length}
                    // className="custom-table__empty"
                    style={{
                      borderBottom: "0",
                      position: "absolute",
                      top: "50%",
                      width: "100%",
                      textAlign: "center",
                    }}>
                    {submissionsListLoading ||
                    networkDetectionsLoading ||
                    iocUrlsLoading ||
                    iocDomainsAndIpsLoading ||
                    iocHashesLoading ||
                    loading
                      ? ""
                      : noDataText}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {paginationButtons && (
          <div
            className={
              paginationBorder
                ? "custom-table__footer-pagination border"
                : "custom-table__footer-pagination"
            }
            style={{
              // bottom: minBottom,
              // position: defaultPosition,
              // backgroundColor: paginationBackColor, //"var(--card-background-color)",
              height: paginationHeight,
            }}>
            {!reportPage && (
              <PageSizeSelect
                value={pageSize}
                defaultSize={customPageSize}
                onChange={pageSizeChangeHandler}
              />
            )}
            <div
              className="custom-table__footer-pagination-arrow"
              onClick={() => {
                setInputPageTriggered(false);
                previousPage();
                setIsPageSwitched(true);
              }}
              disabled={leftIconDisabled}>
              <PaginationLeftIcon
                color={
                  leftIconDisabled
                    ? "var(--dropped--file-pagination-arrow-color)"
                    : "var(--dropped--file-pagination-arrow-active-color)"
                }
              />
            </div>
            {pageOptions.map((number) =>
              number < 1 || pageOptions.length - 2 < number ? (
                <p
                  className={`custom-table__footer-pagination__number${
                    pageIndex === number ? "__active" : ""
                  }`}
                  key={number}
                  onClick={() => pageSwitchHandler(number)}>
                  {number + 1}
                </p>
              ) : (pageIndex < 3 && number < 5) ||
                (pageOptions.length - 4 < pageIndex && pageOptions.length - 6 < number) ? (
                <p
                  className={`custom-table__footer-pagination__number${
                    pageIndex === number ? "__active" : ""
                  }`}
                  key={number}
                  onClick={() => pageSwitchHandler(number)}>
                  {number + 1}
                </p>
              ) : (pageIndex < 3 && number === 5) ||
                (pageOptions.length - 4 < pageIndex && pageOptions.length - 6 === number) ? (
                <p className={`custom-table__footer-pagination__number`} key={number}>
                  ...
                </p>
              ) : pageIndex - 2 < number && pageIndex + 2 > number ? (
                <p
                  className={`custom-table__footer-pagination__number${
                    pageIndex === number ? "__active" : ""
                  }`}
                  key={number}
                  onClick={() => pageSwitchHandler(number)}>
                  {number + 1}
                </p>
              ) : pageIndex - 2 === number || pageIndex + 2 === number ? (
                <p className={`custom-table__footer-pagination__number`} key={number}>
                  ....
                </p>
              ) : null,
            )}
            <div
              className="custom-table__footer-pagination-arrow"
              onClick={() => {
                setInputPageTriggered(false);
                nextPage();
                setIsPageSwitched(true);
              }}
              disabled={rightIconDisabled}>
              <PaginationRightIcon
                color={
                  rightIconDisabled
                    ? "var(--dropped--file-pagination-arrow-color)"
                    : "var(--dropped--file-pagination-arrow-active-color)"
                }
              />
            </div>
            <div className="custom-table__footer-pagination__number-box">
              <input
                className="border"
                type="text"
                value={
                  paginationNumber === 0
                    ? ""
                    : paginationNumber > pageOptions.length
                      ? pageOptions.length
                      : paginationNumber
                }
                onChange={(e) => inputPageSwitchHandler(Number(e.target.value) - 1)}
              />
              <span> | {pageOptions.length}</span>
            </div>
            <Warning
              onClickOk={cleanListHandler}
              show={show}
              setShow={setShow}
              text="Are you sure to delete error submissions from list?"
              article="Warning"
              cancelDisable={false}
              textOK="Yes"
            />
            <Overlay show={isPageSwitched && submissionsListLoading} />
          </div>
        )}
        {refreshButton && (
          <Backdrop
            absolute={true}
            show={
              submissionsListLoading ||
              networkDetectionsLoading ||
              iocUrlsLoading ||
              iocDomainsAndIpsLoading ||
              iocHashesLoading ||
              runningListLoading ||
              loading
            }
          />
        )}
      </div>
    </>
  );
};

export default CustomTable;
